import { CommonModule } from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {ExamService} from "../../data-access/exam.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {faCaretDown, faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {DropdownMenuComponent, MenuItem} from "../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {ActivatedRoute, Router} from "@angular/router";
import {OutlineButtonComponent} from "../../../shared/ui/outline-button/outline-button.component";
import {DropdownSearchComponent} from "../../../shared/ui/dropdown-search/dropdown-search.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {FullButtonComponent} from "../../../shared/ui/full-button/full-button.component";
import {
  PerPagePaginationComponent
} from "../../../shared/ui/pagination/per-page-pagination/per-page-pagination.component";
import {BreadcrumbComponent, BreadcrumbNavigation} from "../../../shared/ui/breadcrumb/breadcrumb.component";

interface SubmissionResponse {
  username: string,
  family_name: string
  display_name: string
  exam_title: string
  complete_by: Date
  examinstance_id: number
  exam_id: number
  exam_uuid: string
  user_id: number
  attempt_no: number
  mode: string
  final_score: number
  available_score: number
  assign_time: Date
  start_time: Date
  answer_time: Date
  due_time: Date
  started_late: boolean
  finished_late: boolean
  menuItems: MenuItem[]
}
export interface Pagination {
  limit: number
  size: number
  page: number
  start: number
  totalcount: number
  maxpage: number
}
@Component({
    selector: 'exam-submissions',
    templateUrl: './exam-submissions.component.html',
    imports: [CommonModule, FontAwesomeModule, DropdownMenuComponent, OutlineButtonComponent, DropdownSearchComponent, FormsModule, MatIconModule, FullButtonComponent, PerPagePaginationComponent, BreadcrumbComponent]
})
export class ExamSubmissionsComponent implements OnInit {
  constructor(examService: ExamService, private route: ActivatedRoute) {}
  examService = inject(ExamService)
  router = inject(Router)
  examTitle = ''
  pageNumber: number = 1
  course_id = -1
  submissionResponse: SubmissionResponse[] = []
  currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  faChevronRight = faChevronRight
  breadcrumNav: BreadcrumbNavigation[] = [{
    text: 'Exam List',
    route: 'dashboard/exam/list'
  }]
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if(params['course_id']) {
        this.course_id = params['course_id']
        this.handleSubmissionResponse(params['course_id'])
      }
      // TODO title can probably be retrieved via exam_id
      if(params['exam_title']) {
        this.examTitle = params['exam_title']
      }
    })
  }

  handlePaginationChange(newPagination: Pagination) {
    this.currentPagination = newPagination
  }

  handleSubmissionResponse(course_id: number) {
    this.examService.getMyExamInstances(course_id, this.currentPagination.limit, this.currentPagination.page).subscribe((response) => {
      if(response.success) {
        this.handlePaginationChange({
          limit: response.result.limit,
          size: response.result.size,
          page: response.result.page,
          start: response.result.start,
          totalcount: response.result.totalcount,
          maxpage: Math.floor(response.result.totalcount / response.result.limit)
        })
        this.submissionResponse = []
        for(let item of response.result.items) {
          this.submissionResponse.push({
            ...item,
            menuItems: [{
              title: 'Review',
              route: 'dashboard/exam/submissions/review',
              queryParams: {queryParams: {exam_uuid: item.exam_uuid, course_id: this.course_id, student: item.display_name, username: item.username}}
            }]
          })
        }
      } else {

      }
    })
  }

  examList() {
    this.router.navigate(['dashboard/exam/list'])
  }

  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faCaretDown = faCaretDown;
}
